import * as _ from 'lodash';
import { Component, OnInit, Input, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { UserService } from 'app/Shared/Services/user.service';
import { DataService } from 'app/Shared/Services/data.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { GridService } from 'app/Shared/Services/grid.service';
import { ConfirmationService } from 'primeng/api';
import { CaisServiceService } from '../../cais-service.service';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { LowerCasePipe, NgClass, CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-cais-customer-search',
    imports: [DialogModule, TableModule, ButtonModule, CommonModule, MatProgressSpinner, LowerCasePipe, NgClass, AutoCompleteModule, FormsModule],
    templateUrl: './cais-customer-search.component.html',
    styleUrls: ['./cais-customer-search.component.scss']
})
export class CAISCustomerSearchComponent implements OnInit {
  @Input('selectedCustomerType') selectedCustomerType!: string;
  @Input('customerKeyword') customerKeyword!: string;
  @Output() selectConfirmCustomer: EventEmitter<any> = new EventEmitter<any>();
  HTTPSubscribedAPI: any;
  isLoadingResults = true;
  tbldatamsg = 'L o a d i n g . . . . .';
  customers: any = [];
  selectedCustomer: Object = {};
  Limit: any = { 'Start': '', 'End': '' };
  rowcount!: number;
  startLimit: any = 0;
  endLimit!: number;
  pageNumber: any = 1;
  totalRecords: number = 0;
  cols!: any[];
  customerDetails!: any[];

  constructor(private UserService: UserService,
    private urlService: UrlsService,
    private gridService: GridService,
    public confirmationService: ConfirmationService,
    public constantService: ConstantService,
    public dataService: DataService,
    private sharedHttpClientService: SharedHttpClientService,
    public caisServiceService: CaisServiceService,
  )  { }

  ngOnInit() {
    this.rowcount = 5;
    this.endLimit = 5;
    this.totalRecords = this.rowcount;
    this.Limit = { 'Start': '0', 'End': this.rowcount };
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.customerKeyword = (this.customerKeyword ? this.customerKeyword.replace(/\s+/g, ' ') : this.customerKeyword); // Convert multiple spaces into single space from searching keyword

    if(this.selectedCustomerType) {
      // Paging Parameters
      this.startLimit = 0;
      this.rowcount = 5;
      this.pageNumber = 1;
      this.totalRecords = this.rowcount;

      // Prepare Customer Table Columns
      let customerGridColumns:any, customerDisplayFields: any;
      if(this.selectedCustomerType === this.constantService.customerTypes[0]) {
        customerGridColumns = this.caisServiceService.NaturalPersonGridColumns;
        customerDisplayFields = ["First Name", "Middle Name", "Last Name", "TID Type", "TID Value"];
      } else if (this.selectedCustomerType === this.constantService.customerTypes[1]) {
        customerGridColumns = this.caisServiceService.LegalEntityGridColumns;
        customerDisplayFields = ["Legal Name", "TID Type", "TID Value"];
      }

      this.cols = customerGridColumns.filter((fieldDetail: { ui_columnname: any; }) => _.includes(customerDisplayFields, fieldDetail.ui_columnname));
      this.cols = this.gridService.getGridColumns(this.cols);
      if(this.cols.length > 0) {
        this.cols = this.cols.map((arrObj) => { return {...arrObj, "display": "true"}});
      }

      // Retrieval of Customer Data
      this.getAllCustomers();
    }
  }

  getAllCustomers() {
    // Cancel All Previously Pending Status APIs
    if (this.HTTPSubscribedAPI) {
      this.HTTPSubscribedAPI.unsubscribe();
    }

    this.customers = [];
    this.isLoadingResults = true;
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.tbldatamsg = 'L o a d i n g . . . . .';

    this.HTTPSubscribedAPI = this.sharedHttpClientService.post(
      this.urlService.setAPIURl(
        APIURL.CAIS_Customer_List
      ), {
        customerKeyword: (this.customerKeyword ? this.customerKeyword : ""),
        customerType: this.selectedCustomerType,
        CATReporterIMID: this.UserService.getActiveMPID(),
        user: this.UserService.getUserName(),
        userName: this.UserService.getUserFirstName(),
        startLimit: this.Limit.Start.toString(),
        endLimit: this.Limit.End.toString()
      }
    ).subscribe({
      next: (element:any) => {
        let dataset: any = element;
        
        this.customers = dataset.Data;
        this.totalRecords = dataset.totalCount;
        this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
        if (this.customers.length === 0) {
          this.tbldatamsg = "No data found";
        }
        this.isLoadingResults = false;
      },error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
    }});
  }

  filterCustomer(event: any) {
    // Paging Parameters
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;
    this.customerKeyword = event.query; // Set customer search Keyword 

    this.sharedHttpClientService.post(
      this.urlService.setAPIURl(
        APIURL.CAIS_Search_Customer
      ), {
        customerKeyword: this.customerKeyword,
        customerType: this.selectedCustomerType,
        CATReporterIMID: this.UserService.getActiveMPID(),
        startLimit: this.Limit.Start.toString(),
        endLimit: this.Limit.End.toString()
      }
    ).subscribe({
      next: (element:any) => {
        let dataset: any = element;
        this.customerDetails = dataset.CustomerList;
      },error: (err: HttpErrorResponse) => {
    }});
  }

  selectcustomer(event: Event, selectedCustomerItem: any) {
    event.preventDefault();
    this.selectedCustomer = selectedCustomerItem;
  }

  changePage(event: any) {
    this.startLimit = event.first;
    this.endLimit = this.startLimit + this.rowcount;
    this.rowcount = event.rows;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;

    // Retrieval of Customer Data
    this.getAllCustomers();
  }

}